import { Dropdown, DropdownProps } from 'task-eva-ui'

export function HeaderDropdown({
  children,
  placement = 'bottomLeft',
  style,
  ...props
}: DropdownProps) {
  return (
    <Dropdown
      placement={placement}
      wrapperActiveBackground='#343538'
      style={{ height: '100%', ...style }}
      {...props}
    >
      {children}
    </Dropdown>
  )
}
